import Images from 'app/assets/img';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as LogoutIcon } from 'app/assets/img/logout.svg';
import { useSelector } from 'react-redux';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import { AGENT_ROUTE } from 'app/pages/Agent/constants';
import RenderIf from 'app/components/RenderIf';
import { Permission } from 'app/hooks/usePermission';
import { BP_TYPE } from 'utils/constants';

export enum ACCOUNT_MNG_MENU {
  PURCHASE_HISTORY,
  ORDER_MANAGEMENT,
  PERSONAL_INFO,
  LOGOUT,
  CHECK_TICKET,
  BOOKING_SLOTS,
  FILES_MANAGEMENT,
  AGENT_HISTORY,
  AGENT_PROFILE,
  APPROVE_ORDER,
  ACCOUNT_PAYMENT_GUIDE,
  AUTO_DEPOSIT,
  AGENT_LIST_ACCOUNT,
}

const AccountManager = (props: {
  onClickHistory?: () => void;
  onClickProfile?: () => void;
  onClickLogout?: () => void;
  menuActive?: ACCOUNT_MNG_MENU;
}) => {
  const { menuActive } = props;

  const { onLogout, onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  const renderMessCofirmLogout = (message: string) => {
    const partsOfMsg = message.split('\\n\\r');
    return partsOfMsg.map(i => <LogoutConfirmMsg>{i}</LogoutConfirmMsg>);
  };

  const onConfirmLogout = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2c.menu.logout'] ?? '',
      content: renderMessCofirmLogout(
        translations?.['b2c.text.logoutConfirm'] ?? '',
      ),
      buttons: [
        {
          text: translations?.['b2c.btn.cancel'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2c.txt.confirm'] ?? '',
          bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
          color: 'white',
          onClick: () => {
            onCloseDialogNoti();
            onLogout();
          },
        },
      ],
      maskClosable: false,
      icon: <LogoutIcon />,
      onCloseDialog: onCloseDialogNoti,
    });
  };

  return (
    <div
      style={{
        borderRadius: 20,
        background: '#FFFFFF',
        padding: 24,
        boxShadow: '0px 20px 20px 0px #0000000D',
      }}
    >
      <div>
        <StyledH4
          style={{
            marginBottom: 24,
            textTransform: 'uppercase',
            color: '#000000',
          }}
        >
          {translations?.['b2c.account.mng'] ?? ''}
        </StyledH4>
      </div>
      {menuActive &&
      [
        ACCOUNT_MNG_MENU.AGENT_HISTORY,
        ACCOUNT_MNG_MENU.AGENT_PROFILE,
        ACCOUNT_MNG_MENU.AGENT_LIST_ACCOUNT,
      ].includes(menuActive) ? (
        <>
          <Link to={AGENT_ROUTE.AGENT_PROFILE}>
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_PROFILE}
            >
              <img src={Images.AgentIcon} alt="" />
              {translations?.['b2b.menu.agent-profile'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          <Link to={AGENT_ROUTE.AGENT_LIST_ACCOUNT}>
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_LIST_ACCOUNT}
            >
              <img src={Images.UserIcon} alt="" />
              {translations?.['b2b.menu.agent-list-account'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          {!isProxyBuyer && (
            <Link to={AGENT_ROUTE.AGENT_TRANSACTION_HISTORY}>
              <StyledAccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_HISTORY}
              >
                <img src={Images.HistoryIcon} alt="" />
                {translations?.['b2b.menu.agent-transaction-history'] ?? ''}
              </StyledAccountMenuItem>
            </Link>
          )}
        </>
      ) : (
        <>
          <Link to="/account">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.PURCHASE_HISTORY}
            >
              <img src={Images.HistoryIcon} alt="" />
              {translations?.['b2c.txt.order-history'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          <RenderIf condition={isSaleMng && !isProxyBuyer}>
            <Link to="/approve-order">
              <StyledAccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.APPROVE_ORDER}
              >
                <img src={Images.CheckTicketIcon} alt="" />
                {translations?.['b2b.txt.approveOrder'] ?? ''}
              </StyledAccountMenuItem>
            </Link>
          </RenderIf>
          <Link to="/order-management">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.ORDER_MANAGEMENT}
            >
              <img
                src={Images.AutoDeposit}
                alt="OrderManager"
                style={{ transform: 'translateX(-3px)', marginRight: 2 }}
              />
              {translations?.['b2b.orderManager'] ?? 'Đơn hàng Combo Holiday'}
            </StyledAccountMenuItem>
          </Link>
          <Link to="/check-tickets">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.CHECK_TICKET}
            >
              <img src={Images.CheckTicketIcon} alt="" />
              {translations?.['b2b.txt.check-ticket'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          <Link to="/restaurant/booking-slots">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.BOOKING_SLOTS}
            >
              <img src={Images.CheckTicketIcon} alt="" />
              {translations?.['b2b.txt.bookingLookup'] ?? 'Tra cứu đặt chỗ'}
            </StyledAccountMenuItem>
          </Link>
          <Link to="/files-management">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.FILES_MANAGEMENT}
            >
              <img src={Images.DocumentIcon} alt="" />
              {translations?.['b2b.account.files-management'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          <Link to="/profile">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.PERSONAL_INFO}
            >
              <img src={Images.UserIcon} alt="" />
              {translations?.['b2c.menu.account'] ?? ''}
            </StyledAccountMenuItem>
          </Link>
          <RenderIf
            condition={
              infoUser?.role_code === Permission.ROLE_SALE_MANAGER &&
              !isProxyBuyer &&
              !!infoUser.businessPartner?.bankInfo?.tid
            }
          >
            <Link to="/auto-deposit">
              <StyledAccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.AUTO_DEPOSIT}
              >
                <img
                  src={Images.AutoDeposit}
                  alt="TopUpDeposit"
                  style={{ transform: 'translateX(-3px)', marginRight: 2 }}
                />
                {translations?.['b2b.autoDeposit'] ?? ''}
              </StyledAccountMenuItem>
            </Link>
          </RenderIf>
          {/* <Link to="/payment-guide">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.ACCOUNT_PAYMENT_GUIDE}
            >
              <img src={Images.AccountPaymentGuideIcon} alt="" />
              {translations?.['b2b.txt.manualDeposit'] ?? ''}
            </StyledAccountMenuItem>
          </Link> */}
          <StyledAccountMenuItem
            onClick={onConfirmLogout}
            isSelected={menuActive === ACCOUNT_MNG_MENU.LOGOUT}
          >
            <img src={Images.LogoutIcon} alt="" />
            {translations?.['b2c.menu.logout'] ?? ''}
          </StyledAccountMenuItem>
        </>
      )}
    </div>
  );
};

export default AccountManager;

const StyledH4 = styled.h4`
  font-weight: 600;
  font-size: 20px;
`;

const StyledAccountMenuItem = styled.div<{
  isSelected: boolean;
}>`
  color: #000000;
  background-color: ${props =>
    props.isSelected ? '#FFEDEB80' : 'transparent'};
  border-radius: 20px;
  width: 100%;
  padding: 12px 16px 12px 16px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  img {
    margin-right: 8px;
  }
`;

const LogoutConfirmMsg = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #1c1b1f;
  text-align: center;
  margin: 0 auto;
  &:not(:first-child) {
    margin-top: 1px;
  }
`;
